module.exports = __webpack_public_path__ + "img/716.28c87bd9.png";